import styled from 'styled-components'
import {
  DialogOverlay as ReachOverlay,
  DialogContent as ReachContent,
} from '@reach/dialog'

export const ModalWrapper = styled(ReachOverlay)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: auto;
`

export const ModalContent = styled(ReachContent)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`
